import React from 'react';

import TaskStatusLabel from '../../../common/TaskStatusLabel';
import { Training } from '../Training.interface';

export interface TrainingTaskStatusLabelsProps {
  training: Training;
}

const TrainingTaskStatusLabels: React.FC<TrainingTaskStatusLabelsProps> = (
  props: TrainingTaskStatusLabelsProps
) => {
  const { training } = props;
  return (
    <>
      {training.version > 1 && (
        <TaskStatusLabel
          // assumes "Approved" status exists
          status='Approved'
          task={training.task}
          getLabel={(label: string) => {
            return `${label} v${training.version - 1}`;
          }}
        />
      )}
      {!training.task?.status.includes('Approved') && (
        <TaskStatusLabel
          task={training.task}
          getLabel={(label: string) => {
            return `${label} v${training.version}`;
          }}
        />
      )}
    </>
  );
};

export default TrainingTaskStatusLabels;
